import { useState } from "react";
import API from "../../services/api";
import { toast } from "react-toastify";

export default function ChangePassword() {
  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!form.current_password) {
      newErrors.current_password = "Wajib diisi";
    }

    if (!form.new_password) {
      newErrors.new_password = "Wajib diisi";
    } else if (form.new_password.length < 6) {
      newErrors.new_password = "Minimal 6 karakter";
    } else if (form.new_password === form.current_password) {
      newErrors.new_password =
        "Password baru tidak boleh sama dengan yang lama";
    }

    if (!form.confirm_password) {
      newErrors.confirm_password = "Wajib diisi";
    } else if (form.new_password !== form.confirm_password) {
      newErrors.confirm_password = "Password tidak cocok";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setSubmitLoading(true);
      const res = await API.post("/change-password", form);
      setForm({
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
      setSubmitLoading(false);
      toast.success("Password berhasil diubah.");
    } catch (err) {
      setSubmitLoading(false);
      setErrors(err.response?.data?.errors || {});
    }
  };

  return (
    <div className="container py-5 d-flex justify-content-center align-items-center">
      <div
        className="card shadow-sm p-4"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <h4 className="mb-4 text-center">
          <i className="bi bi-shield-lock-fill me-2"></i>Ubah Password
        </h4>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Password Lama</label>
            <input
              type="password"
              className={`form-control ${
                errors.current_password ? "is-invalid" : ""
              }`}
              name="current_password"
              value={form.current_password}
              onChange={handleChange}
              placeholder="Masukkan password lama"
            />
            <div className="invalid-feedback">{errors.current_password}</div>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Password Baru</label>
            <input
              type="password"
              className={`form-control ${
                errors.new_password ? "is-invalid" : ""
              }`}
              name="new_password"
              value={form.new_password}
              onChange={handleChange}
              placeholder="Minimal 6 karakter"
            />
            <div className="invalid-feedback">{errors.new_password}</div>
          </div>

          <div className="mb-4">
            <label className="form-label fw-semibold">
              Konfirmasi Password Baru
            </label>
            <input
              type="password"
              className={`form-control ${
                errors.confirm_password ? "is-invalid" : ""
              }`}
              name="confirm_password"
              value={form.confirm_password}
              onChange={handleChange}
              placeholder="Ulangi password baru"
            />
            <div className="invalid-feedback">{errors.confirm_password}</div>
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100 rounded-pill py-2"
            disabled={submitLoading}
          >
            Simpan Perubahan
          </button>
        </form>
      </div>
    </div>
  );
}
